import { LoaderFunctionArgs, redirect } from "react-router";

export default async function workLoader(args: LoaderFunctionArgs) {
  const routeParams = args.params;
  if (!routeParams) return redirect("/work/active");
  return routeParams;
}
